<template>

  <div class="row">
    <div style="clear: both; margin-bottom: 8px; display: block">
      <div style="float: right;  z-index: 0">
        <button
            class="btn btn-success settings-action-btn btn-sm"
            type="button"
            @click="triggerSaveSettings"
        >
          <i class="fas fa-save me-1"></i> Zapisz ustawienia
        </button>
      </div>
    </div>
  </div>

  <CommonSettingsEditor
      ref="packagesSettingsView"
      :settings="currentSettings"
      @onSaveSettings="savePackagesSettings"
      @onTestSettingsGroup="testSettingsGroup"
      :testButtonTitle="'Testuj połączenie'"
  />
</template>
<script>

import CommonSettingsEditor from "@/components/widgets/CommonSettingsEditor.vue";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import Swal from "sweetalert2";

export default {
  name: "PackagesManagerSettingsList",
  props: {},
  components: {
    CommonSettingsEditor,
  },
  data() {
    return {
      currentSettings: [],

    };
  },
  computed: {
    packagesModule(){
      return usePackagesManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  watch: {
    currentSettings: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.currentSettings.sort((item1, item2) => {
            return item1.position - item2.position;
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    testSettingsGroup(payload) {
      const settingsGroup = payload.key;
      const settingsToSave = payload.settingsToSave;
      this.savePackagesSettings(settingsToSave, false).then(() => {

        if (settingsGroup === "1. Połączenie z centralną aplikacją*") {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.commonModule.httpTestRestConnectionSettings({moduleName: "PACKAGES"})

        } else if (settingsGroup === "2. Połączenie z serwerem poczty*") {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.commonModule.httpTestMailServerConnectionSettings({moduleName: "PACKAGES"})

        } else if (settingsGroup === "3. Połączenie FTP*") {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.commonModule.httpTestFtpConnectionSettings({moduleName: "PACKAGES"})

        }
      })

    },
    triggerSaveSettings() {
      this.$refs.packagesSettingsView.emitSave();
    },

    savePackagesSettings(payload, showSuccessDialog = true) {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Zapis ustawień...");
      return this.commonModule.saveSettings(payload).then(() => {
        this.lazyloaderModule.setDisplayLazyLoader(false);
        if (showSuccessDialog) {
          Swal.fire({
            title: "Sukces",
            text: "Ustawienia zostały zapisane",
            icon: "success",
            confirmButtonColor: "#34c38f",
          });
        }
        this.refreshSettingsList();
      });
    },

    refreshSettingsList() {
      this.packagesModule.setPackagesManagerSettings([]);
      var requestPayload = {};
      this.packagesModule.httpGetPackagesManagerSettings(requestPayload).then(() => {
        this.currentSettings = JSON.parse(JSON.stringify(this.packagesModule.getPackagesManagerSettings));
      });
    },
  },

  created() {
    this.refreshSettingsList();
  },
};
</script>

<style scoped>
.slim-style {
  font-size: 0.9em !important;
}
</style>
